import { Directive } from '@angular/core';
/**
 * This directive is used as a tag to easily identify et request an error container view this simple directive using ViewChild
 */
@Directive({
  selector: '[wizErrorContainer]'
})
export class WizValidationErrorContainerDirective {
  // that's just it we do nothing more in here for the moment.
  constructor() { }
}
